import { __assign, __extends, __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
import { UploadMedia } from '../icons';
import styles from './UploadBox.scss';
import UploadInput from './UploadInput';
var UploadBox = /** @class */ (function (_super) {
    __extends(UploadBox, _super);
    function UploadBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        return _this;
    }
    UploadBox.prototype.click = function () {
        if (this.inputRef.current) {
            this.inputRef.current.click();
        }
    };
    UploadBox.prototype.render = function () {
        var _a = this.props, className = _a.className, label = _a.label, hoveredLabel = _a.hoveredLabel, icon = _a.icon, props = __rest(_a, ["className", "label", "hoveredLabel", "icon"]);
        var withHover = !!hoveredLabel;
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement(UploadInput, __assign({ className: classNames(styles.label, className), ref: this.inputRef }, props),
                icon || React.createElement(UploadMedia, { className: styles.labelIcon }),
                React.createElement("span", { className: styles.labelText }, withHover ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: styles.defaultText }, label),
                    React.createElement("span", { className: styles.hoverText }, hoveredLabel))) : (label)))));
    };
    return UploadBox;
}(React.Component));
export default UploadBox;
//# sourceMappingURL=UploadBox.js.map